import React from "react";
import { useTranslation } from "react-i18next";
import { Clock3, MapPin } from "lucide-react";

import { Card, CardContent } from "./ui/card";

import florianopolis from "../assets/images/florianopolis2.jpeg";
import balneario from "../assets/images/balneario.webp";
import blumenau from "../assets/images/blumenau.jpeg";
import garopaba from "../assets/images/garopaba.png";
import bombinhas from "../assets/images/bombinhas.jpeg";
import itapema from "../assets/images/itapema.jpeg";

export default function DestinationsComponent() {
  const { t } = useTranslation();

  const destinations = [
    {
      id: "fln",
      titleKey: "destinations.florianopolis.name",
      image: florianopolis,
      translationKey: "florianopolis.description",
    },
    {
      id: "bnu",
      titleKey: "destinations.balneario.name",
      image: balneario,
      translationKey: "balneario.description",
      timeKey: "balneario.time",
    },
    {
      id: "blu",
      titleKey: "destinations.blumenau.name",
      image: blumenau,
      translationKey: "blumenau.description",
      timeKey: "blumenau.time",
    },
    {
      id: "gar",
      titleKey: "destinations.garopaba.name",
      image: garopaba,
      translationKey: "garopaba.description",
      timeKey: "garopaba.time",
    },
    {
      id: "bom",
      titleKey: "destinations.bombinhas.name",
      image: bombinhas,
      translationKey: "bombinhas.description",
      timeKey: "bombinhas.time",
    },
    {
      id: "ita",
      titleKey: "destinations.itapema.name",
      image: itapema,
      translationKey: "itapema.description",
      timeKey: "itapema.time",
    },
  ];

  return (
    <section className="bg-white py-16">
      <div className="mx-auto flex max-w-5xl flex-col gap-10 px-6">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.4em] text-primary">
            {t("appbar.destinations")}
          </p>
          <h2 className="mt-4 text-3xl font-bold text-slate-900">
            {t("destinations.title")}
          </h2>
          <p className="mt-2 text-base text-muted-foreground">
            {t("destinations.description")}
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {destinations.map((destination) => (
            <Card
              key={destination.id}
              className="overflow-hidden border-none bg-slate-50"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={destination.image}
                  alt={t(destination.titleKey)}
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent" />
              </div>
              <CardContent className="space-y-3 py-6">
                <div className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.3em] text-primary">
                  <MapPin className="h-4 w-4" /> {t(destination.titleKey)}
                </div>
                <p className="text-sm text-slate-600">
                  {t(destination.translationKey)}
                </p>
                {destination.timeKey && (
                  <div className="flex items-center gap-2 text-sm font-medium text-slate-500">
                    <Clock3 className="h-4 w-4" /> {t(destination.timeKey)}
                  </div>
                )}
                <div className="rounded-2xl border border-dashed border-primary/40 p-3 text-xs text-primary">
                  {t("destinations.idealFor")}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
